<div class="inputs-container">
  <textarea #messageInput nz-input [placeholder]="inputPlaceholder()" [disabled]="isInputDisabled()"
    [(ngModel)]="question" (input)="autoResizeTextarea($event)" (keydown.enter)="handleEnterKey($event)"
    (keydown.arrowup)="navigateHistory($event, -1)" (keydown.arrowdown)="navigateHistory($event, 1)"
    rows="1"></textarea>
  <button class="search-buttons" nz-button nzType="primary" [disabled]="isInputDisabled()" (click)="prompt_agent()">
    <span nz-icon nzType="send" nzTheme="outline"></span>
  </button>
</div>
